/**
 * Copyright 2026, IntraLinks, Inc. All rights reserved.
 */

export type SecurityMethod = 'authenticator' | 'sms' | 'email';

const BASE = '/securitysetup';

export const SecuritySetupRoutes = {
  root: BASE,
  enrollTemplate: `${BASE}/enroll/:method`,
  verifyTemplate: `${BASE}/verify/:method`,
  providers: `${BASE}/providers`,
  enrichment: `${BASE}/enrichment`,
  error: `${BASE}/error`,
  loaCallback: `${BASE}/loacallback`,
  enroll: (method: SecurityMethod): string => `${BASE}/enroll/${method}`,
  verify: (method: SecurityMethod): string => `${BASE}/verify/${method}`
} as const;

export default SecuritySetupRoutes;
